import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import BenefitsList from '../../../../benefits/NoBenefits/BenefitsList';

import SilverStarWithPoints from '../../../../../../../../assets/silver_star_with_points.png';
import GoldenStarWithPoints from '../../../../../../../../assets/gold_star_with_points.png';

import noSubscribedStyle from '../styles';

const Categories = (props) => {
  const { mobile, benefits } = props;
  const [openSilver, setOpenSilver] = useState(!mobile);
  const [openGold, setOpenGold] = useState(!mobile);
  const classes = noSubscribedStyle({ mobile });

  const handleOpenSilver = () => {
    setOpenSilver(!openSilver);
    setOpenGold(false);
  };

  const handleOpenGold = () => {
    setOpenGold(!openGold);
    setOpenSilver(false);
  };

  return (
    <React.Fragment>
      <Typography className={classes.tabPanelTitle}>
        Categorías de clientes
      </Typography>
      <Typography className={classes.tabPanelSubtitle}>
        Tus Ripley Puntos Go te permite acceder a increíbles beneficios
      </Typography>
      <Box className={classes.boxCategories}>
        <BenefitsList
          image={SilverStarWithPoints}
          mobile={mobile}
          open={openSilver}
          setOpen={handleOpenSilver}
          benefits={benefits}
          type="Silver"
        />
        <BenefitsList
          image={GoldenStarWithPoints}
          mobile={mobile}
          open={openGold}
          setOpen={handleOpenGold}
          benefits={benefits}
          type="Gold"
        />
      </Box>
    </React.Fragment>
  );
};

Categories.propTypes = {
  mobile: PropTypes.bool,
  benefits: PropTypes.array,
};

export default Categories;
